import React, { useState } from 'react';
import { Tabs } from '../utils/Tabs/Tabs';
import { AlertTable } from '../alert-table/AlertTable';
import { SamplesTable } from '../rmx-service/SamplesTable/SamplesTable';
import { BypassTable } from '../utils/BypassTable/BypassTable';
import { getComponentLifeTableData } from '../../api/userDashboardApi';
import { useRmxServiceApi } from '../rmx-service/api';
import { useQuery } from '@tanstack/react-query';
import { ComponentLifeWrapper } from '../component-life';

export function InsightsTab() {
  const [tab, setTab] = useState('alerts');
  const api = useRmxServiceApi();
  const isAirSystemsUserQuery = useQuery({
      queryKey: ['isAirSystemsUser'],
      queryFn: async () => {
        return await api.isAirSystemsUser();
      }
    }),
    { data: isAirSystemsUser } = isAirSystemsUserQuery;

  return (
    <Tabs
      activeTab={tab}
      setActiveTab={setTab}
      tabs={[
        {
          key: 'alerts',
          title: 'Alerts',
          content: (
            <div>
              <AlertTable />
            </div>
          )
        },
        {
          key: 'predicts',
          title: 'Predictions',
          hide: !isAirSystemsUser,
          content: (
            <div>
              <ComponentLifeWrapper isVisible={true} fromDashboard={true} assetId={0} dataRequester={getComponentLifeTableData} />
            </div>
          )
        },
        {
          key: 'samples',
          title: 'Samples',
          hide: !isAirSystemsUser,
          content: (
            <div>
              <SamplesTable />
            </div>
          )
        },
        {
          key: 'bypasses',
          title: 'Bypasses',
          content: (
            <div>
              <BypassTable />
            </div>
          )
        }
      ]}
    />
  );
}
